// @ts-check

/* eslint-disable @typescript-eslint/no-this-alias */
/**
 * RelivConferenceFeature
 *
 * @param uid
 */
const RelivConferenceFeature = function (uid) {
  /**
   * self
   */
  const self = this;
  /**
   * orderNumber
   *
   * @type {number}
   */
  self.orderNumber = null;
  /**
   * ownerRcn
   *
   * @type {string}
   */
  self.ownerRcn = null;
  /**
   * skuNumber
   *
   * @type {string}
   */
  self.skuNumber = null;
  /**
   * ticketUid *REQUIRED
   *
   * @type {string}
   */
  self.ticketUid = uid;
  /**
   * type
   *
   * @type {string}
   */
  self.type = 'conferenceFeature';
  /**
   * uid *REQUIRED
   *
   * @type {string}
   */
  self.uid = uid;
};

export default RelivConferenceFeature;
